import React from 'react'
import styled from 'styled-components'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import avatarPlaceholder from '../images/avatar-placeholder.png'

export const StyledAvatar = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  display: inline-block;
  img {
    width: 100%;
    height: 100%;
    border: 2px solid #63bed4;
    border-radius: 50%;
    margin: 0;
  }
`

export const Avatar = ({ image, alt }) => {
  return (
    <StyledAvatar>
      {image ? (
        <GatsbyImage image={getImage(image)} alt={alt} />
      ) : (
        <img src={avatarPlaceholder} alt={alt} />
      )}
    </StyledAvatar>
  )
}
